export enum StandingOrdersOrderBy {
  NextPayment = 'nextPayment',
  Beneficiary = 'beneficiary',
  Amount = 'amount',
  Frequency = 'frequency',
  Status = 'status',
  Account = 'account',
}
